import { lazy } from "react";
import { Outlet } from "react-router";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const PGWayAdapterList = ScreenLoader(
  lazy(() => import("../screens/pgway-adapter-screen/PGWayAdapterList")),
);

const PGWayAdapterCreateAccount = ScreenLoader(
  lazy(() => import("../screens/pgway-adapter-screen/PGWayAdapterCreateAccount")),
);

const PGWayAdapterTransfer = ScreenLoader(
  lazy(() => import("../screens/pgway-adapter-screen/PGWayAdapterTransfer")),
);

const PGWayAdapterApprovalTransfer = ScreenLoader(
  lazy(() => import("../screens/pgway-adapter-screen/PGWayAdapterApprovalTransfer")),
);

const PGWayAdapterTransactions = ScreenLoader(
  lazy(() => import("../screens/pgway-adapter-screen/PGWayAdapterTransactions")),
);

//maping the seller route completely
export const PGWayAdapterRoute = () => ({
  path: "pgway-adapter",
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: (
        <RoleGuard requiredPermission="pgwayAdapter" requiredActions={["isRead"]}>
          <PGWayAdapterList />
        </RoleGuard>
      ),
    },
    {
      path: "add-account",
      element: (
        <RoleGuard requiredPermission="pgwayAdapter" requiredActions={["isCreate"]}>
          <PGWayAdapterCreateAccount />
        </RoleGuard>
      ),
    },
    {
      path: "update-account/:id",
      element: (
        <RoleGuard requiredPermission="pgwayAdapter" requiredActions={["isUpdate"]}>
          <PGWayAdapterCreateAccount />
        </RoleGuard>
      ),
    },
    {
      path: "transfer",
      element: (
        <RoleGuard requiredPermission="pgwayAdapterTransfer" requiredActions={["isCreate"]}>
          <PGWayAdapterTransfer />
        </RoleGuard>
      ),
    },
    {
      path: "approval-transfer",
      element: (
        <RoleGuard requiredPermission="pgwayAdapterTransfer" requiredActions={["isUpdate"]}>
          <PGWayAdapterApprovalTransfer />
        </RoleGuard>
      ),
    },
    {
      path: "transactions/:id",
      element: (
        <RoleGuard requiredPermission="pgwayAdapter" requiredActions={["isRead"]}>
          <PGWayAdapterTransactions />
        </RoleGuard>
      ),
    },
  ],
});
